<template>
<v-container>
  <div>
    <v-bottom-navigation v-if="!$route.meta.hideNavigation" color="oug" grow fixed height="40px">
      <v-btn to="/Home">
        <span>Home</span>

        <v-icon>mdi-home-outline</v-icon>
      </v-btn>
            <v-btn to="Calendar">
        <span>Events</span>
        <v-icon>mdi-calendar-outline</v-icon>
      </v-btn>
      <v-btn to="/Drills">
        <span>Drills</span>
        <v-icon>mdi-whistle-outline</v-icon>
      </v-btn>

      <v-btn to="/Videos">
        <span>Videos</span>

        <v-icon>mdi-video-outline</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <v-footer app color="oug" dark elevation="24">
      <v-row class="copy" no-gutters>
        <v-col cols="6" align="start">
          &copy; {{ new Date().getFullYear() }} —
          <strong>{{ title }}</strong>
        </v-col>
      </v-row>
    </v-footer>
  </div>
  </v-container>
</template>

<script>
export default {
  name: "Footer",
  props: {
    title: {
      Type: String,
      Required: true,
    },
  },
};
</script>

<style lang="scss" scoped>

.v-bottom-navigation {
  margin-bottom: env(safe-area-inset-bottom) !important;
}

</style>
